// extracted by mini-css-extract-plugin
export default {"read":"styles_read__2pMcj","unread":"styles_unread__TerHe"};